import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-control',
  templateUrl: './icon-control.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconControlComponent {}
